import { useCallback, useEffect, useState } from 'react';
import { getAllDrafts, saveDraft as saveDraftToDB, deleteDraft as deleteDraftFromDB } from '@/shared/lib/draftService'

export function useDrafts(toolId) {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const all = await getAllDrafts();
      const userId = localStorage.getItem('user_id');
      const owned = all.filter((d) => d.userId && d.userId === userId);
      setDrafts(toolId ? owned.filter((d) => d.toolId === toolId) : owned);
    } catch (err) {
      console.error('Failed to load drafts:', err);
    } finally {
      setLoading(false);
    }
  }, [toolId]);

  useEffect(() => { refresh(); }, [refresh]);

  const save = useCallback(async (draft) => {
    await saveDraftToDB(draft);
    await refresh();
  }, [refresh]);

  const remove = useCallback(async (id) => {
    await deleteDraftFromDB(id);
    await refresh();
  }, [refresh]);

  return { drafts, loading, saveDraft: save, deleteDraft: remove, refreshDrafts: refresh };
}
